module.exports = __webpack_public_path__ + "static/concrete-section-types-880x880-4e9ef5981f589d429df908dd387d6ce5.png";